// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuarantineSummary } from './quarantine-summary';
import {
    QuarantineSummaryFromJSON,
    QuarantineSummaryFromJSONTyped,
    QuarantineSummaryToJSON,
    QuarantineSummaryToJSONTyped,
} from './quarantine-summary';
import type { RunStatistics } from './run-statistics';
import {
    RunStatisticsFromJSON,
    RunStatisticsFromJSONTyped,
    RunStatisticsToJSON,
    RunStatisticsToJSONTyped,
} from './run-statistics';
import type { ReviewStatus } from './review-status';
import {
    ReviewStatusFromJSON,
    ReviewStatusFromJSONTyped,
    ReviewStatusToJSON,
    ReviewStatusToJSONTyped,
} from './review-status';
import type { RunStatus } from './run-status';
import {
    RunStatusFromJSON,
    RunStatusFromJSONTyped,
    RunStatusToJSON,
    RunStatusToJSONTyped,
} from './run-status';
import type { ConformanceError } from './conformance-error';
import {
    ConformanceErrorFromJSON,
    ConformanceErrorFromJSONTyped,
    ConformanceErrorToJSON,
    ConformanceErrorToJSONTyped,
} from './conformance-error';

/**
 * 
 * @export
 * @interface RunListItem
 */
export interface RunListItem {
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    assignedTo?: string;
    /**
     * 
     * @type {Array<ConformanceError>}
     * @memberof RunListItem
     */
    conformanceErrors?: Array<ConformanceError>;
    /**
     * 
     * @type {Date}
     * @memberof RunListItem
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    dataStreamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RunListItem
     */
    dryRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    dtaName?: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    dtaVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    inputLocation?: string;
    /**
     * 
     * @type {Date}
     * @memberof RunListItem
     */
    lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    parentRunId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    quarantineLocation?: string;
    /**
     * 
     * @type {QuarantineSummary}
     * @memberof RunListItem
     */
    quarantineSummary?: QuarantineSummary;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    resolution?: string;
    /**
     * 
     * @type {ReviewStatus}
     * @memberof RunListItem
     */
    reviewStatus?: ReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    runId: string;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    specId: string;
    /**
     * 
     * @type {RunStatistics}
     * @memberof RunListItem
     */
    statistics?: RunStatistics;
    /**
     * 
     * @type {RunStatus}
     * @memberof RunListItem
     */
    status: RunStatus;
    /**
     * 
     * @type {string}
     * @memberof RunListItem
     */
    studyId: string;
}



/**
 * Check if a given object implements the RunListItem interface.
 */
export function instanceOfRunListItem(value: object): value is RunListItem {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('runId' in value) || value['runId'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function RunListItemFromJSON(json: any): RunListItem {
    return RunListItemFromJSONTyped(json, false);
}

export function RunListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'conformanceErrors': json['conformanceErrors'] == null ? undefined : ((json['conformanceErrors'] as Array<any>).map(ConformanceErrorFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'dataStreamId': json['dataStreamId'] == null ? undefined : json['dataStreamId'],
        'dryRun': json['dryRun'],
        'dtaName': json['dtaName'] == null ? undefined : json['dtaName'],
        'dtaVersion': json['dtaVersion'] == null ? undefined : json['dtaVersion'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'inputLocation': json['inputLocation'] == null ? undefined : json['inputLocation'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'parentRunId': json['parentRunId'] == null ? undefined : json['parentRunId'],
        'quarantineLocation': json['quarantineLocation'] == null ? undefined : json['quarantineLocation'],
        'quarantineSummary': json['quarantineSummary'] == null ? undefined : QuarantineSummaryFromJSON(json['quarantineSummary']),
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : ReviewStatusFromJSON(json['reviewStatus']),
        'runId': json['runId'],
        'specId': json['specId'],
        'statistics': json['statistics'] == null ? undefined : RunStatisticsFromJSON(json['statistics']),
        'status': RunStatusFromJSON(json['status']),
        'studyId': json['studyId'],
    };
}

export function RunListItemToJSON(json: any): RunListItem {
    return RunListItemToJSONTyped(json, false);
}

export function RunListItemToJSONTyped(value?: RunListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedTo': value['assignedTo'],
        'conformanceErrors': value['conformanceErrors'] == null ? undefined : ((value['conformanceErrors'] as Array<any>).map(ConformanceErrorToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'dataStreamId': value['dataStreamId'],
        'dryRun': value['dryRun'],
        'dtaName': value['dtaName'],
        'dtaVersion': value['dtaVersion'],
        'errorMessage': value['errorMessage'],
        'fileName': value['fileName'],
        'inputLocation': value['inputLocation'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'parentRunId': value['parentRunId'],
        'quarantineLocation': value['quarantineLocation'],
        'quarantineSummary': QuarantineSummaryToJSON(value['quarantineSummary']),
        'resolution': value['resolution'],
        'reviewStatus': ReviewStatusToJSON(value['reviewStatus']),
        'runId': value['runId'],
        'specId': value['specId'],
        'statistics': RunStatisticsToJSON(value['statistics']),
        'status': RunStatusToJSON(value['status']),
        'studyId': value['studyId'],
    };
}
